import {Typography} from '@mui/material';
import React, {FC} from 'react';

interface TextDiffProps {
  value: string;
  comparedValue: string;
  isBeforeColumn?: boolean;
}

/**
 * Composant pour afficher les différences textuelles mot par mot
 */
export const TextDiff: FC<TextDiffProps> = ({value, comparedValue, isBeforeColumn = false}) => {
  const currentWords = value.split(' ');
  const otherWords = comparedValue.split(' ');

  const diffElements: React.ReactNode[] = [];

  if (isBeforeColumn) {
    const removedWords = currentWords.filter((word) => !otherWords.includes(word));

    currentWords.forEach((word, idx) => {
      if (removedWords.includes(word)) {
        diffElements.push(
          <Typography
            key={`removed-${idx}`}
            component="span"
            sx={{
              backgroundColor: '#fecaca',
              color: '#dc2626',
              padding: '2px 4px',
              borderRadius: '3px',
              textDecoration: 'line-through',
              fontWeight: 500,
            }}
          >
            {word}
          </Typography>,
        );
      } else {
        diffElements.push(word);
      }
      if (idx < currentWords.length - 1) diffElements.push(' ');
    });
  } else {
    const addedWords = currentWords.filter((word) => !otherWords.includes(word));

    currentWords.forEach((word, idx) => {
      if (addedWords.includes(word)) {
        diffElements.push(
          <Typography
            key={`added-${idx}`}
            component="span"
            sx={{
              backgroundColor: '#dcfce7',
              color: '#166534',
              padding: '2px 4px',
              borderRadius: '3px',
              fontWeight: 500,
            }}
          >
            {word}
          </Typography>,
        );
      } else {
        diffElements.push(word);
      }
      if (idx < currentWords.length - 1) diffElements.push(' ');
    });
  }

  return (
    <Typography
      variant="body2"
      sx={{
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontSize: '0.875rem',
        lineHeight: 1.2,
      }}
    >
      {diffElements}
    </Typography>
  );
};
